import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import Headline5 from '../Typography/Heading/Headline5';
import Anchor from '../Anchor';
import breakpoints from '../Theme/breakpoints';

export const SubContainer = styled.div`
  display: block;
  max-width: 1392px;
  padding: 0;
  box-sizing: border-box;
  margin: 0 auto;

  @media (min-width: ${breakpoints.sm}px) {
    display: flex;
    margin-bottom: 48px;
    flex-wrap: wrap;
  }

  @media (min-width: ${breakpoints.lg}px) {
    justify-content: space-between;
  }
`;

export const StyledDiv = styled.div`
  flex-basis: auto;

  @media (min-width: ${breakpoints.sm}px) {
    margin-bottom: 48px;
    flex-basis: calc(50%);
  }

  @media (min-width: ${breakpoints.lg}px) {
    flex-basis: auto;
    flex-wrap: nowrap;
    margin-bottom: 0;
  }
`;

export const StyledListItem = styled.li`
  &&& {
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: ${({ theme }) => theme.sizes.subtitle1};
    padding: 24px 0;

    @media (min-width: ${breakpoints.md}px) {
      padding: inherit;
    }
  }
`;

export const StyledAnchor = styled(Anchor)`
  color: rgba(255, 255, 255, 0.7);
`;

export const Title = styled(Headline5)`
  && {
    color: ${({ theme }) => theme.colors.white};
    /* stylelint-disable-next-line selector-type-no-unknown */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      color: #FFF;
    }
  }
`;

export const FooterListItem = styled.li`
  &&& {
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: ${({ theme }) => theme.sizes.h6};
    padding: 0 0 24px;
    color: rgba(255, 255, 255, 0.7);

    @media (min-width: ${breakpoints.md}px) {
      padding: inherit;
    }
  }
`;

export const FooterTitle = styled(Headline5)`
  && {
    color: ${({ theme }) => theme.colors.white};
    padding: 8px 0 20px;
    @media (min-width: ${breakpoints.md}px) {
      padding: inherit;
    }

    /* stylelint-disable-next-line selector-type-no-unknown */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      color: #FFF;
    }
  }
`;

const FooterContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.blackHigh};
  padding: 48px 24px 48px;

  @media (min-width: ${breakpoints.sm}px) {
    padding: 48px 24px 72px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    padding: 96px 48px 72px;
  }

  /* stylelint-disable-next-line selector-type-no-unknown */
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    background-color: rgba(0, 0, 0, .87);
  }
`;

const footerPropertyTypes = {
  children: PropTypes.node,
};

type AlertBarProperties = InferProps<typeof footerPropertyTypes>;

export const Footer = ({ children }: AlertBarProperties) => (
  <FooterContainer className="fu-footer">
    {children}
  </FooterContainer>
);

Footer.propTypes = footerPropertyTypes;

export { default as Mini } from './Mini';
